/* Curated rules only. A visit seed changes priority, never prices or discounts. */
(function () {
  'use strict';
  function rank(id, seed) {
    var hash = 2166136261;
    var value = seed + ':' + id;
    for (var i = 0; i < value.length; i++) hash = Math.imul(hash ^ value.charCodeAt(i), 16777619);
    hash ^= hash >>> 16; hash = Math.imul(hash, 0x7feb352d);
    hash ^= hash >>> 15; hash = Math.imul(hash, 0x846ca68b);
    return (hash ^ (hash >>> 16)) >>> 0;
  }
  function choose(rules, cartIds, fallback, limit, seed, rotate) {
    var inCart = new Set(cartIds.map(String));
    var matching = rules.filter(function (rule) { return rule.sources.some(function (id) { return inCart.has(String(id)); }); });
    var pool = matching.length ? matching.flatMap(function (rule) { return rule.cards; }) : fallback;
    var seen = new Set();
    pool = pool.filter(function (card) {
      var id = String(card.id);
      if (inCart.has(id) || seen.has(id)) return false;
      seen.add(id); return true;
    });
    if (rotate) pool.sort(function (a,b) { return rank(a.id,seed)-rank(b.id,seed) || String(a.id).localeCompare(String(b.id)); });
    return pool.slice(0,Math.max(1,Math.min(3,Number(limit) || 3)));
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {choose:choose}; return; }
  if (customElements.get('md-cart-recommendations')) return;
  var key = 'md-cart-offer-visit-v1', visit;
  try { visit = JSON.parse(sessionStorage.getItem(key)); } catch (_) {}
  if (!visit || typeof visit.seed !== 'string' || Date.now()-Number(visit.last) > 30*60*1000) {
    visit = {seed: String(crypto.getRandomValues(new Uint32Array(1))[0]),last:Date.now()};
  }
  function touchVisit() {
    visit.last = Date.now();
    try { sessionStorage.setItem(key,JSON.stringify(visit)); } catch (_) {}
  }
  touchVisit();
  // Activity extends this visit. Re-rendering never changes the seed mid-page.
  document.addEventListener('pointerdown',touchVisit,{passive:true});
  document.addEventListener('keydown',touchVisit,{passive:true});
  function cards(template) {
    return template ? Array.from(template.content.querySelectorAll('.md-cart-offer')).map(function (node) { return {id:node.dataset.productId,node:node}; }) : [];
  }
  class Recommendations extends HTMLElement {
    connectedCallback() { this.render(); }
    render() {
      var config = document.querySelector('[data-md-pairing-config]');
      var rules = [];
      if (config && this.dataset.pairings === 'true') {
        rules = Array.from(config.querySelectorAll('[data-md-pairing-rule]')).map(function (template) {
          return {sources:JSON.parse(template.dataset.sourceIds),cards:cards(template)};
        });
      }
      var selection = choose(rules,JSON.parse(this.dataset.cartIds || '[]'),cards(this.querySelector('[data-md-general-offers]')),this.dataset.limit,visit.seed,Boolean(config && config.dataset.rotate === 'true'));
      var old = this.querySelector('[data-md-offer-results]'); if (old) old.remove();
      if (!selection.length) return;
      var section = document.createElement('section'); section.className = 'md-cart-offers';
      section.dataset.mdOfferResults = ''; section.setAttribute('aria-label',this.dataset.heading);
      var heading = document.createElement('h3'); heading.textContent = this.dataset.heading;
      section.appendChild(heading);
      selection.forEach(function (card) { section.appendChild(card.node.cloneNode(true)); });
      this.appendChild(section);
    }
  }
  customElements.define('md-cart-recommendations',Recommendations);
  document.addEventListener('shopify:section:load',function () {
    document.querySelectorAll('md-cart-recommendations').forEach(function (host) { host.render(); });
  });
})();
